<template>
    <div class="plugins box">
        <h2>{{ t('places-plugins-title') }}</h2>

        <div class="add-filter-holder">
            <div class="filter add-filter" @click.prevent="showPlugins = !showPlugins">
                <span class="far fa-plus"></span>
                <span> {{ t('places-plugins-add_plugin') }} </span>
            </div>
            <div class="filter-options" v-if="showPlugins">
                <span class="far fa-remove pull-right" @click="showPlugins = false"></span>
                <label>{{ t('places-plugins-choose_plugin') }} </label>
                <div class="clear"></div>
                <ul>
                    <li style="cursor: pointer" v-for="plugin in plugins" :key="plugin">
                        <router-link class="col-12" :to="`/plugin/${plugin}`">{{ plugin }}</router-link>
                    </li>
                </ul>
            </div>
        </div>

        <grid @loaded="onLoad" :showSearch="false" source="plugins/list" :filters="{ placeId: $route.params.id }">
            <template v-slot:rows="grid">
                <thead class="bg-white">
                    <tr>
                        <grid-th :grid="grid" class="text-dark" attr="id">{{ t('id') }}</grid-th>
                        <grid-th :grid="grid" class="text-dark" attr="plugin">{{ t('plugin') }}</grid-th>
                        <grid-th :grid="grid" class="text-dark" attr="external_id">{{ t('places-plugins-external_id') }}</grid-th>
                        <grid-th :grid="grid" class="text-dark" attr="created">{{ t('places-plugins-created_at') }}</grid-th>
                        <grid-th :grid="grid" class="text-dark text-center">{{ t('actions') }}</grid-th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="plugin in grid.data" :key="plugin.id">
                        <td>
                            {{ plugin.id }}
                        </td>
                        <td>
                            {{ plugin.plugin }}
                        </td>
                        <td>
                            {{ plugin.external_id }}
                        </td>
                        <td>
                            <human-date :date="plugin.created" format="[d]/[M]/[Y]" />
                        </td>
                        <td>
                            <button class="bnt btn-primary m-2" @click="$router.push(
                                { path: '/plugin/' + plugin.plugin, query: { id: plugin.id } }
                            )">
                                <i class="fa fa-pencil"></i>
                            </button>
                            <button class="bnt btn-warning m-2" @click="$router.push(
                                '/plugin/' + plugin.id + '/import-history'
                            )">
                                <span class="mdi mdi-history"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </template>
        </grid>

        <div class="clear"></div>
    </div>
</template>

<script>
import HumanDate from "../../../components/human-date/human-date";

export default {
    data() {
        return {
            showPlugins: false,
            plugins: []
        };
    },
    components: {
        HumanDate
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        onLoad(data) {
            if (data?.response?.plugins) {
                for (let k in data.response.plugins) {
                    this.plugins[k] = data.response.plugins[k];
                }
            }
        },
    }
};
</script>

<style lang="less" scoped>
ul {
    max-height: 204px;
    overflow-y: auto;

    li {
        padding: 0px;

        a {
            display: block;
            padding: 8px 12px;
            color: #333;
            &:hover {
                text-decoration: none;
            }
        }
    }
}
</style>
